import { Selector } from "@ngxs/store";
import { FindProOrganizerRequestByUserInitialState, FindProOrganizerRequestByUserState } from "./find-by-user.state";

export class FindProOrganizerRequestByUserSelectors {
    @Selector([FindProOrganizerRequestByUserState])
    static findProOrganizerRequestByUser(state: FindProOrganizerRequestByUserInitialState) {
        return state.data;
    }

    @Selector([FindProOrganizerRequestByUserState])
    static findProOrganizerRequestByUserLoading(state: FindProOrganizerRequestByUserInitialState) {
        return state.loading;
    }

    @Selector([FindProOrganizerRequestByUserState])
    static findProOrganizerRequestByUserError(state: FindProOrganizerRequestByUserInitialState) {
        return state.error;
    }
}